import { asMultiStyleConfig } from '../../utils/theme';
var parts = ['requiredIndicator', 'helperText'];
var baseStyleRequiredIndicator = {
  color: 'red.700'
};
var baseStyleRequiredText = {
  fontSize: 'md',
  color: 'black',
  fontWeight: 'normal'
};
var baseStyleHelperText = {
  mt: -1,
  mb: 3,
  lineHeight: 'normal',
  fontSize: 'sm',
  _groupDisabled: {
    color: 'grey.800'
  }
};
var baseStyle = {
  requiredIndicator: baseStyleRequiredIndicator,
  requiredText: baseStyleRequiredText,
  helperText: baseStyleHelperText
};
export default asMultiStyleConfig({
  parts,
  baseStyle
});